import { Grid, Typography, WithStyles } from "@material-ui/core";
import * as React from "react";

import { ProductSPRHelper } from "../../helper/ProductSPR.helper";
import { Beneficiary } from "../../types/Beneficiary";
import { Customer } from "../../types/Customer";
import { Form } from "../../types/Form";
import { Products } from "../../types/Products";
import { ProductSPR, productSPRBeneficiaryClauseItems, productSPRSamplingIntervals } from "../../types/ProductSPR";
import { Quotation } from "../../types/Quotation";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import Contribution from "../Contribution/Contribution";
import { ErrorForm } from "../ErrorForm/ErrorForm";
import InputRadio from "../InputRadio/InputRadio";
import InputSelect from "../InputSelect/InputSelect.component";
import { Warning } from "../Warning/Warning";
import { quotationFormStyles } from "./QuotationForm.styles";
import QuotationFormBeneficiaries from "./QuotationFormBeneficiaries";

interface QuotationProductSPRProps extends WithStyles<typeof quotationFormStyles> {
    mode?: "calculator";
    productHelper: ProductSPRHelper;
    customer: Customer;
    quotation: Quotation;
    showError(message: string);
    hideError();
    onChange(product: Products);
}

type QuotationProductSPRState = {
    form: Form<Products>;
};

class QuotationFormProductSPR extends React.Component<QuotationProductSPRProps, QuotationProductSPRState> {
    private formBuilder = null;

    public async componentWillMount() {
        this.updateState(this.props);
    }

    public componentWillReceiveProps(nextProps: QuotationProductSPRProps) {
        this.updateState(nextProps);
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        const form = builder.exec(this.state.form);
        this.setState({ form: form });
        this.props.onChange(form.values);
    }

    public onChangeBeneficiaries(beneficiaries: Beneficiary[]) {
        let product: ProductSPR = this.props.quotation.product as ProductSPR;
        product.beneficiaries = beneficiaries;
        this.props.onChange(product);
    }

    public render() {
        if (!this.state || !this.props.customer || !this.props.customer.birthdate) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const product: ProductSPR = this.props.quotation.product as ProductSPR;

        return (
            <>
                {/* Mode de prélèvement */}

                <div className={this.props.classes.box}>
                    <Typography
                        variant={this.props.mode === "calculator" ? "headline" : "title"}
                        gutterBottom={true}
                        className={this.props.classes.formTitle}
                    >
                        {this.props.mode === "calculator" ? "Mode de prélèvement" : "4/ Mode de prélèvement"}
                    </Typography>
                    <Grid container={true} spacing={16}>
                        <Grid item={true}>
                            <InputRadio {...uiForm.fields.samplingInterval} />
                        </Grid>
                    </Grid>
                </div>

                {/* Garanties */}

                <div className={this.props.classes.box}>
                    <Typography
                        variant={this.props.mode === "calculator" ? "headline" : "title"}
                        gutterBottom={true}
                        className={this.props.classes.formTitle}
                    >
                        {this.props.mode === "calculator" ? "Garanties" : "5/ Garanties"}
                    </Typography>
                    <Grid container={true} spacing={16} className={this.props.classes.guarantyBoxBackground}>
                        <Grid item={true} sm={4}>
                            <InputSelect {...uiForm.fields.annuityAge85} />
                        </Grid>
                        {product && product.annuityImmediate && (
                            <Grid item={true} sm={8}>
                                <Typography
                                    variant="body1"
                                    gutterBottom={true}
                                    className={this.props.classes.annuityImmediateItem}
                                >
                                    Soit une rente dépendance immédiate de <b>{product.annuityImmediate}€</b> / mois.
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </div>

                {/* Cotisations */}

                {product && product.contribution && (
                    <div className={this.props.classes.box}>
                        <Typography
                            variant={this.props.mode === "calculator" ? "headline" : "title"}
                            gutterBottom={true}
                            className={this.props.classes.formTitle}
                        >
                            {this.props.mode === "calculator" ? "Cotisations" : "6/ Cotisations"}
                        </Typography>
                        <div className={this.props.classes.cotisationsBox}>
                            <Warning>
                                Votre adhésion est soumise à une déclaration d'état de santé. Vous devez faire parvenir
                                votre Déclaration d'Etat de Santé (et votre questionnaire médical si nécéssaire) au
                                médecin conseil dans l'enveloppe confidentielle prévue à cet effet.
                            </Warning>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxTitle}>
                                <b>
                                    Votre profil médical sera étudié par le médecin conseil d'AG2R LA MONDIALE. Celui-ci
                                    statuera sur :
                                </b>
                            </Typography>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxItem}>
                                L'acceptation de votre adhésion <u>sans surprime.</u>
                                <br />
                                Votre cotisation sera de{" "}
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContribution()}
                                    interval={product.samplingInterval}
                                />
                                .
                            </Typography>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxItem}>
                                <u>L'application d'une surprime</u> sur votre adhésion, si vous répondez par
                                l'affirmative à au moins une question de la Déclaration d'état de santé. Vous recevrez
                                alors une nouvelle proposition d'adhésion à retourner signée dans l'enveloppe jointe.
                            </Typography>
                            <Typography variant="body1" className={this.props.classes.cotisationsBoxItem}>
                                <u>Le refus.</u> Vous recevrez alors un courrier d’information.
                            </Typography>
                        </div>
                        <div className={this.props.classes.cotisationsBoxResume}>
                            <Typography variant="display3" className={this.props.classes.cotisationsBoxResumeItem}>
                                <b>RÉSUMÉ</b>
                            </Typography>
                            <Typography variant="display3" className={this.props.classes.cotisationsBoxResumeItem}>
                                Votre cotisation périodique sera de{" "}
                                <Contribution
                                    value={this.props.productHelper.getPeriodicContribution()}
                                    interval={product.samplingInterval}
                                />{" "}
                                en cas d'acceptation sans surprime.
                            </Typography>
                        </div>
                    </div>
                )}

                {/* Bénéficiaires */}

                {this.props.mode !== "calculator" && product && product.contribution ? (
                    <div className={this.props.classes.box}>
                        <Typography variant="title" gutterBottom={true} className={this.props.classes.formTitle}>
                            7/ Bénéficiaires
                        </Typography>
                        <Grid container={true} spacing={16}>
                            <Grid item={true} sm={12}>
                                <InputRadio {...uiForm.fields.beneficiaryClause} />
                            </Grid>
                            {product.beneficiaryClause === "beneficiary" ? (
                                <Grid item={true} sm={12}>
                                    <QuotationFormBeneficiaries
                                        classes={this.props.classes}
                                        beneficiaries={product.beneficiaries}
                                        onChange={this.onChangeBeneficiaries.bind(this)}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>
                    </div>
                ) : null}

                {/* Error */}

                {this.state.form.errors && this.state.form.errors[0] ? (
                    <ErrorForm classes={this.props.classes} message={this.state.form.errors[0]} />
                ) : null}
            </>
        );
    }

    private updateState(nextProps: QuotationProductSPRProps) {
        const product = this.updateProduct(nextProps);

        this.formBuilder = new UiFormBuilder<Products>();

        this.formBuilder

            // Mode de prélèvement

            .addField("samplingInterval", {
                props: {
                    items: productSPRSamplingIntervals,
                },
            })

            // Garanties

            .addField("annuityAge85", {
                props: {
                    items: this.props.productHelper.getAnnuitiesAge85(),
                    required: true,
                    label: "Rente dépendance à 85 ans",
                    legend: "(Si l'épargne constituée n'est pas versée à l'assuré)",
                },
            })

            // Cotisation

            .addField("consent", {
                props: {
                    label:
                        "Je consens à ce que mes données de santé soient utilisées dans le cadre de la gestion de mon contrat d'assurance.",
                },
            })

            // Bénéficiaires

            .addField("beneficiaryClause", {
                props: {
                    name: "beneficiaryClause",
                    items: productSPRBeneficiaryClauseItems,
                    required: true,
                },
            });

        this.formBuilder.onChange(this.onChange.bind(this));

        let error = "";

        this.setState({
            form: {
                fields: {},
                errors: [error],
                values: product,
            },
        });
    }

    private updateProduct(props) {
        let product = props.quotation.product as ProductSPR;

        if (product && product.annuityAge85) {
            try {
                product.annuityImmediate = this.props.productHelper.getAnnuityImmediate();
                product.contribution = this.props.productHelper.getContribution();
                this.props.hideError();
            } catch (e) {
                this.props.showError(e.message);
            }
        }

        return product;
    }
}

export default QuotationFormProductSPR;



// WEBPACK FOOTER //
// ./src/components/QuotationForm/QuotationFormProductSPR.tsx